module.exports = __webpack_public_path__ + "img/2.02c50a4b.svg";